import { accessNested } from 'utils/utils';

export function filterUnusedPages(props, items) {
	const pages = accessNested(props, 'appData.pages');
	return items.filter(item => pages[item.path] || item.path?.match(/^https?:\/\//i) || item.path?.startsWith('@') || item.path?.startsWith('mailto:') || item.forceShow);
}
